module.exports = __webpack_public_path__ + "img/bg_function05_2_t.ed71d716.svg";